import { createElement } from 'react'

import { Dialog } from '@/components/ui/Dialog'
import { dialogStore } from '@/store/ui/dialog.store'

interface OpenMessageParams {
  title?: string
  message?: string
  confirmMessage?: string
  cancelMessage?: string
  confirmCallback?: () => void
  cancelCallback?: () => void
  cancelVisible?: boolean
}

export const dialog = {
  openMessage: ({
    title,
    message,
    confirmMessage = '확인',
    cancelMessage = '취소',
    confirmCallback = () => null,
    cancelCallback = () => null,
    cancelVisible = false,
  }: OpenMessageParams) => {
    return new Promise<boolean>((resolve) => {
      dialogStore.setState({
        dialogComponent: createElement(Dialog, {
          title,
          message,
          confirmMessage,
          cancelMessage,
          onClickConfirm: () => {
            confirmCallback()
            resolve(true)
          },
          onClickCancel: () => {
            cancelCallback()
            resolve(false)
          },
          cancelVisible,
        }),
        visible: true,
      })
    })
  },
  cancel: () => {
    dialogStore.setState({
      dialogComponent: null,
      visible: false,
    })
  },
}
